import * as ents from '@attain-apps/entities'

import type { Plugin } from './plugin'

/**
 * Selectors for the sender plugin
 */
export class Selectors {
  /**
   * The conversation's info entries grouped onto their messages, each in the
   * order they were produced.
   */
  public readonly infoByMessageId
  /**
   * The conversation's messages, each with the entries it is made of.
   *
   * Messages and entries are cached separately, as they are published; this is
   * the reading that puts a message back together.
   */
  public readonly messagesWithInfo

  constructor(plugin: Plugin) {
    this.infoByMessageId = plugin.feature.state.project(({ infoEntriesById }) =>
      Object.values(infoEntriesById).reduce<
        Record<ents.core.agent.Message['id'], ents.core.agent.Info.Stored[]>
      >((byMessageId, stored) => {
        const entries = byMessageId[stored.messageId]
        if (entries) {
          entries.push(stored)
        } else {
          byMessageId[stored.messageId] = [stored]
        }
        return byMessageId
      }, {}),
    )

    this.messagesWithInfo = this.infoByMessageId.project(
      plugin.collection.plugins.currentListPlugin.feature.selectors.entities
        .asSelector,
      (
        infoByMessageId,
        messages,
      ): readonly ents.core.agent.Message.WithInfo[] =>
        (messages ?? []).map(message => ({
          ...message,
          info: ents.core.agent.Info.Stored.merge(
            message.info,
            infoByMessageId[message.id] ?? [],
          ).info,
        })),
    )
  }
}
